import { render, staticRenderFns } from "./ErrorsPage.vue?vue&type=template&id=3794cc90&scoped=true"
import script from "./ErrorsPage.vue?vue&type=script&lang=js"
export * from "./ErrorsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3794cc90",
  null
  
)

export default component.exports